import {useStorage} from "@/api/storage/local";
import {v4 as uuidv4} from "uuid";
import {WebStorageServiceInterface} from '@/services/WebStorageService';

export const AUTOLOGIN_SESSION_ID: string = 'autologin_session_id';

interface AutoLoginParams {
    targeturi?: string
}

interface AutoLoginSSORequest {
    url: string,
    html: boolean,
    sessionId: string
}

export function startAutoLogin(params: AutoLoginParams = {}): void {

    const storage: WebStorageServiceInterface = useStorage() as WebStorageServiceInterface;
    const sessionId: string = uuidv4(); // Generate unique session id for receiving auth token by it
    const formElement: HTMLFormElement = document.createElement('form');
    const hiddenInputElement: HTMLInputElement = document.createElement('input');
    const url: URL = new URL(`${window.location.origin}/login/sso`);

    if (params.targeturi) {
        url.searchParams.append('targeturi', params.targeturi)
    }

    storage.set(AUTOLOGIN_SESSION_ID, sessionId)

    const request: AutoLoginSSORequest = {
        url: url.href,
        html: false,
        sessionId: sessionId,
    }

    // Create form on the fly and submit it to platform API
    formElement.setAttribute('method', 'POST');
    formElement.setAttribute('action', `${process.env.VUE_APP_AUTH_API_URL}/api/v2/sso/login`);
    hiddenInputElement.setAttribute('type', 'hidden')
    hiddenInputElement.setAttribute('name', 'RelayState')
    hiddenInputElement.setAttribute('value', JSON.stringify(request));
    formElement.appendChild(hiddenInputElement);

    document.body.appendChild(formElement);

    formElement.submit();
}